// The junk check on a Theme AI task (#1891): where the Run step offers it,
// what it found, and how a decision is made. It shows the controls and never
// clicks Proceed or Save decision: both start or commit something.

import type { Walkthrough } from './types'

export const themeAIJunkCheck: Walkthrough = {
  slug: 'theme-ai-junk-check',
  title: 'Check for junk answers',
  summary: 'Opens a Theme AI task, moves to its Run step and shows the junk check and its confirmation, then how the flagged answers are reviewed and what each choice does. Nothing is started or saved.',
  issue: '#1891',
  added: '2026-10-20',
  skipE2E: 'needs a Theme AI task with a code frame on the fixture job',
  steps: [
    {
      page: 'theme-ai-tasks',
      feature: 'themeai/task-list',
      control: 'Open task',
      say: 'This is the list of Theme AI tasks. I will open one that already has a code frame.',
    },
    {
      page: 'theme-ai-tasks',
      feature: 'themeai/task-list',
      click: 'Open task',
      say: 'Opening the task.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/run',
      click: 'Run step',
      say: 'Its Run step, where coding starts. A task that has already run opens on Results, so I move to Run.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/junk-check',
      control: 'Check',
      say: 'Above the test, the junk check looks for empty answers, random characters, “n/a” and copied text before you pay to code them. It is optional. It needs the task owner and AI access level 2. A task already checked says how many junk answers were found, with Review and Check again.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/junk-check',
      click: 'Check',
      say: 'Opening the check’s confirmation. Nothing starts yet.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/junk-check',
      control: 'Proceed',
      say: 'The box shows how many answers the free rules have already flagged and what the model reading the rest will spend. Proceed starts the check. A walkthrough never clicks it.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/junk-check',
      click: 'Cancel, close without checking',
      say: 'Closing the box without starting anything.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/junk-check',
      say: 'When a check finishes, Review lists each flagged answer with why it was flagged and whether a rule or the model flagged it. Switch Keep on for any real answer, and it is coded as usual.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/junk-check',
      say: 'Then choose: Keep all codes everything as usual. Drop them leaves the flagged answers out of the base. Code them as junk / no answer gives them code 99 without the model, so they stay in the base as a row. Save decision keeps the choice, and the run confirmation says how many answers it takes away from the model.',
    },
  ],
}
